import React, { useEffect } from 'react';

/*Hooks*/
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

/*Components*/
import { Button, Box } from '@mui/material';

/*Actions*/
import { onDeleteTestEvent } from '@store/common/actions';

/*Icons*/
import { IconArrowBack } from '@tabler/icons-react';

/*Selectors*/
import { getStatusTesting } from '@store/common/selector';
import { getUserData } from '@store/user/selector';

const eventId = localStorage.getItem('eventId');
const accessToken = localStorage.getItem('accessToken');

const CheckTestEvent = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const statusTesting = useSelector(getStatusTesting);
  const userData = useSelector(getUserData);

  const handleCloseTest = () => {
    if (statusTesting === 'testing' && !!accessToken && (!!userData?.eventId || !!eventId)) {
      dispatch(
        onDeleteTestEvent({
          eventId: userData?.eventId ?? eventId,
          userCreated: userData?.id,
        }),
      );
    }
  };

  return (
    <Box>
      {statusTesting === 'testing' && (!!userData?.eventId || !!eventId) && (
        <Button
          aria-label="Testing Mode"
          color="inherit"
          variant="text"
          aria-controls="msgs-menu"
          aria-haspopup="true"
          sx={{
            color: 'primary.main',
          }}
          onClick={handleCloseTest}
          startIcon={<IconArrowBack size="15" style={{ marginTop: '2px' }} />}
        >
          {t('CORE:close_testing')}
        </Button>
      )}
    </Box>
  );
};

export default CheckTestEvent;
